@use 'src/globals/main';

$border: 0.0625em;
$radius: 0.5em;

$timing: 0.3s;

pn-select {
  display: inline-block;
}

pn-select .pn-select {
  &-label {
    @include main.pn-input-label;
  }

  &-input {
    position: relative;
  }

  &-icon {
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    background-color: transparent;
    &[data-default] {
      right: 0.75em;
    }
    &[data-custom] {
      left: 0.75em;
      ~ .pn-select-element {
        padding-left: 3em;
      }
    }
    &[data-error] {
      right: 3em;
      ~ .pn-select-element {
        padding-right: 5em;
      }
    }
  }

  &-element {
    cursor: pointer;

    @include main.pn-input-field;
    width: 100%;
    padding-right: 3em;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &:disabled {
      @include main.pn-disabled;
    }

    &[data-placeholder] {
      @include main.pn-placeholder;
    }

    &:hover {
      color: main.$input-color;
      background-color: main.$input-background-hover;
    }
  }

  &-no-results {
    margin: 0;
    padding: 0.75em;
  }

  &-helper {
    @include main.pn-input-helpertext;
    &[role='alert'] {
      color: main.$helpertext-color-error;
    }
  }

  &[data-error] {
    > .pn-select-label {
      color: main.$warning;
    }
    > .pn-select-input > .pn-select-element {
      @include main.pn-input-field-error;
      &:hover {
        background-color: main.$input-background-error-hover;
      }
    }
  }
}
